<template>
  <a-button
    :loading="false"
    @click="closeTicket"
    v-if="IsShwoBtn && typebtn === 'default'"
    :type="typebtn"
    >{{ btnName }}</a-button
  >
  <a
    :style="{ color: '#2f7bff' }"
    href="javascript:void(0)"
    :loading="false"
    class="theme-color"
    @click="closeTicket"
    v-if="IsShwoBtn && typebtn === 'text'"
    :type="typebtn"
    >{{ btnName }}</a
  >
  <a-modal
    :centered="true"
    :keyboard="false"
    :mask-closable="false"
    v-model:visible="visible"
    title="取消开票"
    ok-text="确认"
    cancel-text="取消"
    @ok="ok"
  >
    <a-form layout="vertical" :model="formModel" ref="formRef">
      <a-form-item label="取消开票">
        <a-textarea
          placeholder="请输入取消开票原因，最多200字"
          v-model:value="formModel.remark"
          showCount
          :rows="4"
          :maxlength="200"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, computed } from "vue";
import { getCurrentUserId } from "@/utils";
import { message } from "ant-design-vue";
import { updateStatusTicketManage, updateStatusOffPayment } from "../ticket-manage-btn.service";
import _ from "lodash";
export default defineComponent({
  isGlobal: true,
  name: "CloseTicketBtn",
  props: {
    typebtn: {
      type: String,
      default: "default",
    },
    basicInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    bizType: {
      type: String,
      required: true,
    },
    // 业务状态字段名
    updateStatus: {
      type: String,
      default: "invoiceStatus",
    },
    btnName: {
      type: String,
      default: "取消开票",
    },
    btnStatus:{
      type: String,
      default: "qxkp",
    }
  },
  emits: ["refresh", "update:loading"],
  setup(props, { emit }) {
    const state = reactive({
      currentUserId: getCurrentUserId(),
    });
    // 取消开票按钮显隐
    const IsShwoBtn = computed(() => {
      return (
        (props.basicInfo.createBy === state.currentUserId  || props.basicInfo.finalReviewerFlag) &&
        ((props.basicInfo.flowStatus === "spbtg" &&
          props.basicInfo[props.updateStatus] === "cwlcz") ||
          (props.basicInfo.flowStatus === "sptg" &&
            (props.basicInfo[props.updateStatus] === "dkp" ||
              props.basicInfo[props.updateStatus] === "dsp")))
      );
    });
    const visible = ref(false);
    const { bizType, basicInfo } = props;
    const formModel = reactive({
      status: props.btnStatus,
      bizId: basicInfo.id,
      bizType,
      remark: "",
    });
    //修改发票状态流
    const { run: runTicket } = updateStatusTicketManage();

    // 开票申请=>同步 取消申请 改业务状态  资金流
    const { run: runOff } = updateStatusOffPayment();
    const updateStatusOffPaymentData = reactive({
      status: "qxkp",
      bizId: basicInfo.invoiceApplicationId,
      bizType: "invoice_application_examine",
    });

    let loading = ref(false);
    const closeTicket = () => {
      visible.value = true;
      formModel.remark = "";
    };
    const ok = async () => {
      try {
        emit("update:loading", true);
        const res = await runTicket(formModel);
        if (res.respCode !== "0000") {
          message.error(res.respDesc);
          return;
        }
        message.success(res.respDesc);
        if (props.bizType === "make_invoice_examine") {
          await runOff(updateStatusOffPaymentData);
        }
        visible.value = false;
        emit("refresh");
      } finally {
        emit("update:loading", false);
      }
    };

    return {
      loading,
      visible,
      formModel,
      IsShwoBtn,
      ok,
      closeTicket,
    };
  },
});
</script>
